import script from "./pQr.vue?vue&type=script&setup=true&lang=js"
export * from "./pQr.vue?vue&type=script&setup=true&lang=js"

import "./pQr.vue?vue&type=style&index=0&id=02475afa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02475afa"]])

export default __exports__